export enum ExploreElementType {
  Person = 'person',
  Ranking = 'ranking',
  Ai = 'ai',
  Event = 'event',
  Contest = 'contest',
}

export interface ExploreElement {
  id: string;
  uid: string;
  name: string;
  type: ExploreElementType;
  startDate: Date;
  endDate?: Date; // Optional, falls nicht für alle Typen relevant
  favorite: boolean;
  location?: string; // Ort (z.B. "Berlin", "New York")
  lat?: number; // Latitude für Karten-Integration
  lng?: number; // Longitude für Karten-Integration
  description?: string; // Beschreibung des Elements
  nationality?: string; // Nationalität (z.B. "German", "American")
  gender?: string;
  age?: number;
  ageRange?: { min: number; max: number }; // Altersbereich für Filter
}

export interface FilterData {
  locations: string[]; // Filter für Orte
  nationalities: string[]; // Filter für Nationalitäten
  selectedContinents?: string[]; // Ausgewählte Kontinente für Pills-Anzeige
  elementTypes: ExploreElementType[];
  favorites: boolean;
  searchQuery?: string;
  genders?: string[];
  ageRange?: { min: number; max: number };
}